import * as Yup from "yup";

export const updateProfileSchema = Yup.object({
  precedence: Yup.number()
    .typeError("Precedence must be a number")
    .integer("Must be a whole number")
    .min(1, "Minimum is 1")
    .required("Precedence is required"),
  selectionStrategy: Yup.string()
    .oneOf(["ALL", "ONE"])
    .required("Selection strategy is required"),
  routingTypes: Yup.array()
    .min(1, "Select at least one routing type")
    .required(),
  cardTypes: Yup.array().min(1, "Select at least one card type").required(),
  processors: Yup.array().min(1, "Select at least one processor").required(),
  forcePrecedence: Yup.boolean().optional(),
});

export const createProfileSchema = Yup.object({
  precedence: Yup.number()
    .typeError("Precedence must be a number")
    .integer("Must be a whole number")
    .min(1, "Minimum is 1")
    .required("Precedence is required"),
  selectionStrategy: Yup.string()
    .oneOf(["ALL", "ONE"])
    .required("Selection strategy is required"),
  routingTypes: Yup.array()
    .min(1, "Select at least one routing type")
    .required(),
  cardTypes: Yup.array().min(1, "Select at least one card type").required(),
  processors: Yup.array().min(1, "Select at least one processor").required(),
  forcePrecedence: Yup.boolean().optional(),
});

export const routeConfigItemSchema = Yup.object().shape({
  code: Yup.string()
    .required("Code is required")
    .min(1, "Code cannot be empty"),
  name: Yup.string()
    .required("Name is required")
    .min(1, "Name cannot be empty"),
});

export const routeConfigSchema = Yup.object().shape({
  routingTypes: Yup.array()
    .of(routeConfigItemSchema)
    .min(1, "At least one routing type is required"),
  processors: Yup.array()
    .of(routeConfigItemSchema)
    .min(1, "At least one processor is required"),
  cardTypes: Yup.array()
    .of(routeConfigItemSchema)
    .min(1, "At least one card type is required"),
});
